'use client'

import React from 'react'

type Props = {
    radius: number
    angleDeg: number
}

const WIDTH = 340
const HEIGHT = 220

// Math.cos/sin aren't guaranteed bit-identical between Node (SSR) and the
// browser (CSR) - rounding coordinates avoids a hydration mismatch from a
// 1-ULP-different float producing a different toString() on each side.
const r2 = (n: number) => Math.round(n * 100) / 100

export default function CircleSectorChart({ radius, angleDeg }: Props) {
    const r = 80
    const cx = WIDTH / 2
    const cy = HEIGHT / 2
    const angle = Math.min(Math.max(angleDeg, 0), 360)

    const startAngle = -90 // start straight up
    const endAngle = startAngle + angle
    const toRad = (deg: number) => (deg * Math.PI) / 180
    const x1 = r2(cx + r * Math.cos(toRad(startAngle)))
    const y1 = r2(cy + r * Math.sin(toRad(startAngle)))
    const x2 = r2(cx + r * Math.cos(toRad(endAngle)))
    const y2 = r2(cy + r * Math.sin(toRad(endAngle)))
    const largeArc = angle > 180 ? 1 : 0

    const sectorPath = angle >= 360
        ? `M ${cx - r} ${cy} A ${r} ${r} 0 1 1 ${cx + r} ${cy} A ${r} ${r} 0 1 1 ${cx - r} ${cy} Z`
        : `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} Z`

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <circle cx={cx} cy={cy} r={r} fill="none" stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <path d={sectorPath} fill="#2563eb" opacity={0.28} stroke="#2563eb" strokeWidth={2} />
            <text x={cx} y={cy - r - 12} fontSize={12} textAnchor="middle" fill="#374151">
                r = {radius.toFixed(2)}, θ = {angleDeg.toFixed(1)}°
            </text>
        </svg>
    )
}
